import api from '@/services/api';

export async function getFees() {
  const response = await api.get('/config/fees');
  return response.data;
}
